var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"classify"}},[_c('van-nav-bar',{staticClass:"classify-title",attrs:{"z-index":"1"}},[_c('p',{attrs:{"slot":"title"},slot:"title"},[_vm._v(" 分类搜索 ")])]),_c('searchContent',{attrs:{"businessProperty":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }